const flatten = require('flat');

const frLang = flatten({
  notFound: 'Page not found',
  goToHomePage: "Retour à la page d'accueil",
  title: 'Linkpick',
  home: {
    name: 'Linkpick',
    products: 'Produits',
    price: 'Tarifs',
    aPropos: 'À propos',
    connect: 'Je me connecte',
    inscrit: "Je m'inscris",
  },
  chooseProfil: {
    title: 'Choisissez votre type de compte',
    choiceOne: "En recherche d'emploi",
    choiceTwo: 'Entreprise',
    choiceThree: 'Etablissement de formation',
    confirm: 'Cliquez pour confirmer',
  },
  signUp: {
    title: 'Inscrivez-vous avec un tiers compte',
    google: "S'inscrire avec Google",
    apple: "S'inscrire avec Apple",
    facebook: "S'inscrire avec Facebook",
    session: 'Garder ma session ouverte sur cet appareil',
    confirm: 'Créer un compte',
    without: 'ou',
    politique:
      "En créant un compte, vous acceptez les <condition>conditions d'utilisation</condition>, " +
      'la <cookies>politique relative aux cookies</cookies> et la <confidentiality>politique de confidentialité de Linkpick</confidentiality>. ' +
      'Vous consentez à recevoir des communications marketing de la part de Linkpick.' +
      'Vous pouvez vous en désinscrire en cliquant sur le lien contenu dans ces messages ' +
      "ou en suivant la procédure indiquée dans nos conditions d'utilisation.",
  },
  confirmSignUp: {
    title: 'Complétez la derniére étape',
    subTitle: "nécessaire pour l'inscription",
    form: {
      adressePostale: 'Adresse postale',
      codePostale: 'Code postale',
      telephone: 'Numéro de téléphone',
      siren: 'Numéro de Siren',
      cni: "Carte d'identité (pdf.png.jpeg)",
      mode: 'Vous venez principalement pour:',
      confirm: 'Confirmer votre inscription',
    },
  },
  confirmSignUpParticular: {
    title: 'Complétez la derniére étape',
    optionnel: 'optionnel',
    subTitle: '(nécessaire pour obtenir un profil vérifié)',
    form: {
      adressePostale: 'Adresse postale',
      codePostale: 'Code postale',
      telephone: 'Numéro de téléphone',
      siren: 'Numéro de Siren',
      cni: "Carte d'identité (pdf.png.jpeg)",
      photoVisage: 'Photo de votre visage (pdf.png.jpeg)',
      mode: 'Vous venez principalement pour:',
      confirm: 'Confirmer votre inscription',
    },
  },
  school: {
    btnSend: 'Envoyer',
    dashboard: {
      title: 'Tableau de bord',
      subTitle: 'Synthèse de mon compte',
      etudiants: {
        title: 'Classes',
        entreprise: 'Apprenants en entreprises',
        totalEtudiant: 'Apprenants intégrés',
        envoye: 'Contrats à envoyer',
        attente: 'Contrats en attente des autres parties',
        attente2: 'Contrats en attente de votre signature',
      },
      affiliations: {
        title: 'Affiliations',
        attente: 'En attentes des apprenants',
        complete: 'Complétés par tous',
      },
      formationsCandidats: {
        title: 'Formations & Candidats',
        ouverte: 'Offres de formation en cours',
        ferme: 'Offres de formation fermées',
        candidat: 'Candidatures reçues',
      },
      partenaires: {
        title: 'Partenaires',
        nombre: 'Entreprises',
        emploi: "Offres d'emploi proposées",
        student: 'Apprenants chez nos partenaires',
      },
      message: {
        entreprise: "Vos messages d'entreprises",
        entrepriseVide: "Vous n'avez aucun message d'entreprises",
        etudiant: "Vos messages d'apprenants",
        etudiantVide: "Vous n'avez aucun message de vos apprenants",
      },
    },
    formationsCandidats: {
      title: 'Formations & Candidats',
      subTitle: "Ma gestion d'offres de formation",
      subMenu: {
        formations: 'Formations',
        candidats: 'Candidats',
      },
      searchFormation: 'Intitulé de la formation',
      btnPublierFormation: 'Publier une formation',
      btnVoirCandidats: 'Voir les candidats',
      btnVoirCandidat: 'Voir le profil',
      btnVoirOffre: "Voir l'offre",
      publierFormation: 'Publier une formation',
      publierFormationTitle: 'Publiez une formation et générez des candidats',
      search: 'Recherche',
      voirMembre: 'Voir le candidat',
      contactMembre: 'Contacter le candidat',
      ajouterAffiliation: 'Ajouter à vos affiliations',
      transfererDocument: 'Transférer un document',
      membre: 'Candidat',
      formationChoisie: 'Formation choisie',
      niveauEtude: "Niveau d'étude",
      dernierDiplome: 'Dernier diplôme',
      statut: 'Statut',
      niveauInteret: "Niveau d'intérêt",
      dateCandidature: 'Date de candidature',
      nomPrenom: 'Nom et prénom du candidat',
      diplome: 'Niveau de diplôme',
      formation: 'Formation choisie',
      lieu: 'Adresse postale ou ville',
      entreprise: 'Entreprise',
    },
    vitrine: {
      title: 'Vitrine',
      subTitle: 'Personnaliser ma vitrine',
      subTitleBusiness: 'Personnaliser ma vitrine',
      subTitleExterneSchool: 'Etablissement de formation',
      subTitleExterneBusiness: 'Entreprise',
      presentation: {
        title: 'Présentation',
      },
      matiere: {
        title: 'Matières enseignées',
      },
      info: {
        title: 'Informations pratiques',
      },
      formation: {
        title: 'Nos formations',
      },
      partner: {
        title: 'Nos entreprises partenaires',
      },
      jpo: {
        title: 'Journées portes ouvertes',
      },
      offer: {
        title: "Nos offres d'emploi partenaires",
        categorieTitle: 'Consultez les offres par catégories',
      },
      modify: {
        profilName: {
          title: 'Modifier',
        },
      },
      description: 'Description',
      descriptionSub: 'Décrivez votre établissement pour les utilisateurs',
      information: 'Informations',
    },
    classes: {
      title: 'Classes',
      subTitle: 'Ma gestion de classes',
      research: {
        title: 'Recherchez vos classes',
        newClassButton: 'Créer une classe',
        invitButton: 'Inviter des apprenants',
      },
      detail: {
        title: 'Rechercher vos apprenants',
        newClassButton: 'Créez une classe',
        invitButton: 'Inviter des apprenants',
      },
      invite: {
        title: 'Inviter des apprenants',
        subTitle: 'Ajouter des apprenants à une classe existante',
      },
      result: {
        card: {
          button: 'Voir la classe',
        },
      },
    },
    document: {
      title: 'Documents',
      subTitle: 'Émis, reçus et importés',
    },
    createClasse: {
      title: 'Créez une classe',
      subTitle:
        'Insérez les informations relatifs à une offre de formation puis invitez vos apprenants pour suivre leurs avancées.',
    },
  },
  sidebar: {
    bonjour: 'Bonjour',
    parametre: 'Paramètres',
    logout: 'Se déconnecter',
  },
  business: {
    dashboard: {
      title: 'Tableau de bord',
      subTitle: 'Synthèse de mon compte',
      incompleteVitrine: {
        title: 'Votre vitrine est incomplète.',
        subtitle: 'Améliorez votre marque employeur.',
      },
      jobCandidates: {
        title: 'Emplois & Candidats',
        annoucements: 'Annonce(s) ouverte(s)',
        totalCandidates: 'Total de candidat(s)',
      },
      dashboardBtns: {
        tasksbtn: 'Notification(s) à lire',
        partnerbtn: 'Demander un partenariat',
        partnerActive: 'Partenariat en cours',
        partnerPending: 'Demande en attente',
        studentinvitbtn: 'Inviter un apprenant',
      },
      affiliations: {
        title: 'Affiliations',
        attente: 'Affiliation(s) en attente',
        complete: 'Affiliation(s) complétées',
      },
      team: {
        title: 'Equipes',
        students: 'Etudiant(s)',
        notify: 'Notifications',
      },
      partenaires: {
        title: 'Ecoles partenaires',
        nombre: 'Nombre de partenaire(s)',
        formation: 'Nombre de formation(s)',
      },
      message: {
        school: {
          title: "Vos messages d'écoles partenaires",
        },
        team: {
          title: "Vos messages d'équipes",
        },
      },
    },
    profil: {
      title: 'Tableau de bord',
      subTitle: 'Synthèse de mon compte',
      description: {
        title: 'Description',
        subtitle: 'Décrivez votre profil et vos porjets à venir:',
        explaination: 'Vous venez principalement pour:',
      },
      criteria: {
        title: 'Critères de recherche',
      },
      transport: {
        title: 'Moyens de transport',
      },
      interest: {
        title: "Centre d'intérêt",
      },
      permit: {
        title: 'Permis de conduire',
      },
      resume: {
        title: 'Profil',
        subtitle: 'Votre CV en ligne',
        education: {
          title: 'Formations',
        },
        experience: {
          title: 'Expériences',
        },
        certification: {
          title: 'Certifications',
        },
        achievement: {
          title: 'Vos liens & réalisations',
        },
      },
      competencies: {
        title: 'Profil',
        subTitle: 'Mon CV en ligne',
        competenciesPro: {
          title: 'Compétences professionnelles',
        },
        software: {
          title: 'Logiciels',
        },
        language: {
          title: 'Langues',
        },
        competenciesPerso: {
          title: 'Mes qualités personnelles',
        },
        languageProg: {
          title: 'Langages de programmation',
        },
      },
    },
    annoncesCandidats: {
      title: 'Emplois & Candidats',
      subTitle: 'Ma gestion d’offres d’emploi',
      subMenu: {
        annonce: 'Emplois',
        candidat: 'Candidats',
      },
      searchAnnonce: 'Intitulé du poste',
      btnPublierAnnonce: 'Publier une offre',
      publierAnnonceTitle: "Publiez une offre d'emploi",
      publierAnnonceSubTitle: 'Formulaire de dépôt d’offre d’emploi',
      publierAnnonce: 'Publiez',
    },
    teams: {
      title: 'Equipes',
      subTitle: 'Ma gestion d’équipes',
      research: {
        title: 'Recherchez une équipe',
        newClassButton: 'Créer une équipe',
        invitButton: 'Inviter des apprenants',
      },
      detail: {
        title: 'Recherchez vos apprenants',
        newClassButton: 'Créez une équipe',
        invitButton: 'Inviter des apprenants',
      },
      result: {
        card: {
          button: "Voir l'équipe",
        },
      },
    },
    document: {
      title: 'Documents',
      subTitle: 'Transmis et reçus',
    },
    listCandidat: {
      infoPerso: 'Informations personnelles',
      poste: 'Intitulé du poste',
      experience: 'Expérience',
      levelStudy: "Niveau d'étude",
      lastDiplome: 'Dernier diplôme',
      statut: 'Statut',
      niveauInteret: "Niveau d'intérêt",
      dateCandidature: 'Date de candidature',
    },
    vitrine: {
      description: 'Description',
      descriptionSub: 'Décrivez votre entreprise pour les utilisateurs',
      goodtoknow: 'Bon à savoir',
      goodtoknowSub:
        'Ces informations sont particulièrement consultées par les utilisateurs',
      whattheyseek: "Ce qu'ils recherchent",
      whattheyseekSub:
        'Ces informations sont particulièrement consultées par les utilisateurs',
    },
  },
  createUserForm: {
    nom: 'Nom',
    prenom: 'Prénom',
    mail: 'Adresse email',
    mdp: 'Mot de passe',
    cp: 'Code postal',
    btn: 'Créer mon compte',
    phone: 'Numéro de téléphone',
  },
  createBusinessForm: {
    nom: "Nom de l'organisation",
    phone: 'Téléphone',
    mail: 'Adresse e-mail',
    mdp: 'Mot de passe',
    cp: 'Code postal',
    adresse: 'Adresse postale',
    kbis: 'Numéro Kbis',
    siret: 'SIRET',
    ape: 'Code APE',
    opco: 'OPCO',
    website: 'Site web',
  },
  signIn: {
    mail: 'Adresse mail',
    mailInput: 'votre@mail.com',
    mdp: 'Mot de passe',
    mdpInput: '********',
    btn: 'Se connecter',
    loading: 'Chargement',
    google: 'Se connecter avec Google',
    apple: 'Se connecter avec Apple',
    facebook: 'Se connecter avec Facebook',
  },
  student: {
    dashboard: {
      title: 'Tableau de bord',
      subTitle: 'Synthèse de mon compte',
      formationsCandidatees: {
        title: 'Formations candidatées',
        subTitle: 'Nombre de candidatures',
      },
      formationsSauvegardees: {
        title: 'Formations sauvegardées',
        subTitle: 'Nombre de sauvegardes',
      },
      offresCandidatees: {
        title: 'Offres candidatées',
        subTitle: 'Nombre de candidatures',
      },
      offresSauvegardees: {
        title: 'Offres sauvegardées',
        subTitle: 'Nombre de sauvegardes',
      },
      notify: {
        title: 'Mes notifications',
        message: 'Vous avez actuellement',
        notification: 'notification(s)',
        btnVoir: 'Voir les notifications',
      },
      monEcole: {
        title: 'Mon établissement de formation',
        btnValiderAffiliation: "Valider l'affiliation",
        btnContacter: 'Contacter',
        votreFormation: 'Votre formation',
        enAttente: "(En attente d'affiliation)",
      },
      monEntreprise: {
        title: 'Mon entreprise',
        btnTransmettreDoc: 'Transmettre un document',
        btnContacter: 'Contacter',
        btnDeclarerAbsence: 'Déclarez une absence',
        btnVoirContrat: 'voir le contrat tripartite',
        votreFormation: 'Votre formation',
      },
    },
    profil: {
      title: 'Profil',
      subTitle: 'Mon CV en ligne ',
      updateCoordonnees: 'Modifier vos coordonnées',
      btnVisibleCV: 'Visible par les recruteurs',
      btnInvisibleCV: 'Non visible par les recruteurs',
      btnPlusActions: "Afficher plus d'actions",
      subMenu: {
        apropos: 'A propos de moi',
        competences: 'Mes compétences',
        cv: 'Mon parcours',
      },
      description: {
        title: 'Présentation',
        subTitle:
          'Ces informations sont particulièrement consultées par les recruteurs',
        explaination: 'Vous venez principalement pour:',
      },
      personnalinfos: {
        subTitle:
          'Indiquez les informations qui aideront les utilisateurs à plus facilement vous trouver',
      },
      criteria: {
        title: 'Critères de recherche',
        subTitle:
          'Ces informations sont particulièrement consultées par les recruteurs',
      },
      contact: {
        title: 'Informations du contact',
      },
      transport: {
        title: 'Moyens de transport',
        type: {
          voiture: 'Voiture',
          scooter: 'Scooter',
          moto: 'Moto',
          commun: 'Transport',
          velo: 'Vélo',
          trottinette: 'Trottinette',
        },
      },
      interest: {
        title: "Centres d'intérêt",
      },
      permis: {
        title: 'Permis de conduire',
        table: {
          nom: 'Catégorie',
          date: "Date d'obtention",
          pays: "Pays d'obtention",
        },
      },
      competencesPro: {
        title: 'Compétences professionnelles',
        niveauExp: "Niveau d'expérience",
        table: {
          nom: 'Domaines',
        },
      },
      software: {
        title: 'Logiciels',
        table: {
          logiciel: 'Logiciel',
          niveau: 'Niveau',
        },
      },
      language: {
        title: 'Langues',
        table: {
          nom: 'Langue',
          niveau: 'Niveau',
        },
      },
      competencesPerso: {
        title: 'Qualités personnelles',
      },
      languageProg: {
        title: 'Langages de programmation',
        table: {
          langue: 'Langage',
          niveau: 'Niveau',
        },
      },
      education: {
        title: 'Formations',
      },
      experience: {
        title: 'Expériences',
      },
      certification: {
        title: 'Certifications',
      },
      realisation: {
        title: 'Vos liens & réalisations',
        table: {
          nom: 'Nom du fichier',
          format: 'Format',
        },
      },
    },
    souscription: {
      title: 'Souscriptions',
      subTitle: "Mes alertes d'offres",
      subMenu: {
        ecoles: 'Formations',
        entreprises: 'Emplois',
      },
      offreDispo: 'offre(s) disponible(s)',
      preference: {
        title: 'Préférences',
        mail: "En cochant, vous acceptez d'être informé par e-mail ",
        sms: "En cochant, vous acceptez d'être informé par sms ",
        carte:
          'En cochant, vous acceptez de recevoir les annonces dans ma carte',
      },
    },
    settings: {
      title: 'Paramètres',
      subTitle: 'Configurer les paramètres de votre compte',
      subMenu: {
        infos: {
          title: 'Informations du compte',
        },
        security: {
          title: 'Informations sécurité et confidentialité',
          item: {
            global: {
              title: 'Paramètres généraux du compte',
              subTitle: 'Gérer les informations générales de votre compte',
              fullName: 'Nom complet',
              phone: 'Numéro de téléphone',
              verify: 'Verifier',
              modify: 'Modifier',
              pendingVerification: 'Votre compte est en cours de vérification',
              notVerified: "Votre compte n'est pas vérifié",
              verified: 'Votre compte est vérifié',
              email: 'Email',
              safetyEmail: 'Email de secours (facultatif)',
              confirmIdentity: "Confirmation d'identité",
              modal: {
                modifyEmail: "Modifiez l'email",
                modifySafetyEmail: "Modifiez l'email de secours",
                modifyPhone: 'Modifiez le numéro de téléphone ',
                verifyPhone: 'Vérifiez le numéro de téléphone',
                verifyIdentity: 'Vérifier le compte',
              },
            },
            password: {
              title: 'Mot de passe',
              subTitle: 'Un mot de passe fort protège mieux votre compte',
              currentPassword: 'Mot de passe actuel',
              newPassword: 'Nouveau mot de passe',
              repeatNewPassword: 'Répétez nouveau mot de passe',
            },
            session: {
              title: 'Sessions en cours',
              subTitle: 'Voir vos connexions actives',
            },
            mfa: {
              title: 'Authentification double facteurs',
              subTitle:
                'Activer cette fonctionnalités permet de renforcer la sécurité',
            },
            profilVerif: {
              title: 'Vérification de votre profil',
              subTitle: 'Justifier votre identité pour plus de visibilité',
            },
            invoice: {
              title: 'Factures',
              subTitle: 'Voir vos factures',
            },
            paymentInfo: {
              title: 'Informations de paiement',
              subTitle: 'Gérer vos informations de paiement',
            },
            subscription: {
              title: 'Votre abonnement',
              subTitle: 'Gérer votre abonnement',
            },
          },
        },
      },
    },
    candidature: {
      title: 'Candidatures',
      subTitle: "Auprès d'écoles et d'entreprises",
    },
  },
  vitrine: {
    lieu: 'Adresse postale',
    webSite: 'Site web',
    phone: 'Numéro de téléphone',
    sector: "Secteur d'activité",
    tailleEntreprise: 'Nombre de collaborateurs',
    tailleEtablissement: 'Nombre de collaborateurs',
    siege: 'Siège social',
    type: 'Type',
    publicPrive: "Type d'organisme",
    specialization: 'Spécialisation',
    dateCreation: 'Fondé en',
    btnVoirFormation: 'Voir la formation',
    btnVoirEntreprise: 'Voir la vitrine',
    btnVoirEtablissement: 'Voir la vitrine',
    editPresentation: 'Modifier mes informations',
    address: 'Adresse postale',
    adresse: {
      libelle: 'Libellé',
      city: 'Ville',
      code: 'Code',
    },
    email: 'Adresse mail',
    btnUpdate: 'Modifier',
    label: 'Label',
    description: 'Description',
    btnCreate: 'Enregistrer',
    editDescription: 'Modifiez votre présentation',
    nosOffres: "Nos offres d'emploi partenaires",
    nosEcole: 'Nos établissements de formation partenaires',
    level: 'Niveau',
    ville: 'Ville',
  },
  addInterest: "Ajouter un centre d'intérêt",
  addCompetencePerso: 'Ajouter une qualité personnelle',
  addCompetencePro: 'Ajouter une compétence professionnelle',
  editCompetencePro: 'Modifier une compétence professionnelle',
  addLang: 'Ajouter une langue',
  addLangPro: 'Ajouter un langage de programmation',
  addSoftware: 'Ajouter un logiciel',
  btnSearch: 'Rechercher',
  levelDiplome: 'Niveau de diplôme',
  cycleAlternance: "Cycle d'alternance",
  levelStudy: "Niveau d'étude",
  typeContrate: 'Type de contrat',
  salaire: 'Salaire brut',
  dureeContrat: 'Durée du contrat',
  profilVerif: 'Profils vérifiés',
  langRequis: 'Langue(s) requise(s)',
  langEnseignement: "Langue(s) d'enseignement(s)",
  domainePro: 'Domaine professionnel',
  secteurMetier: 'Secteur de metier',
  dureeTravail: 'Durée de travail',
  filter: 'Filtres',
  mySouscriptions: 'Mes souscriptions',
  formations: 'Formations',
  offres: 'Emplois',
  searchLabel: 'Intitulé du poste / de la formation',
  searchLabelPoste: 'Intitulé du poste',
  searchLabelFormation: 'Intitulé de formation',
  searchVille: 'Ville',
  addSchoolSubscribe: {
    title: "Ajouter une souscription d'offres de formation",
  },
  addBusinessSubscribe: {
    title: "Ajouter une souscription d'offre d'emploi",
  },
  map: {
    schools: 'Etablissements de formation',
    trainingDomains: "Domaine(s) d'étude(s)",
    jobDomains: 'Domaine(s) pro. souhaité(s)',
    jobs: 'Type(s) de poste souhaité(s)',
    desiredContractLength: 'Durée de contrat souhaitée',
    diplome: 'Niveau de diplome',
    trainingTypes: 'Type(s) de formation',
    studyPlans: 'Présence',
    businesses: 'Entreprises',
  },
  laoding: 'Chargement',
  addEducation: {
    title: 'Ajouter une formation',
    label: 'Intitulé de la formation',
    school: 'Etablissement de formation',
    city: 'Ville',
    startDate: 'Date début',
    endDate: 'Date fin',
    titleEdit: 'Editez la formation',
  },
  addEditExperience: {
    title: 'Ajouter un expérience',
    label: 'Intitulé du poste',
    company: 'Entreprise',
    city: 'Ville',
    startDate: 'Date début',
    endDate: 'Date fin',
    contractType: 'Type de contrat',
    titleEdit: 'Editez mon expérience',
  },
  addCertification: {
    title: 'Ajouter une certification',
    titleEdit: 'Editez la certification',
    label: 'Label',
    reference: 'Référence',
    issuingCompany: 'Entreprise',
    issueDate: 'Date de délivrance',
    expirationDate: "Date d'expiration",
  },
  btnDelete: 'Supprimer',
  noElements: 'Aucune information à afficher',
  subscribe: {
    label: 'Nom de ma souscription',
    alertFrequency: 'Fréquence',
    Frequency: 'Fréquence',
    city: 'Ville',
    businesses: 'Entreprise(s)',
    schools: 'Etablissement(s) de formation',
    sectors: 'Secteur(s) de métier(s)',
    domains: "Domaine(s) d'étude(s)",
    contractTypes: 'Type(s) de contrat(s)',
    degrees: 'Niveau(x) de diplôme(s) ',
    levels: 'Niveau(x) détude(s)',
    studyPlans: 'Présence(s)',
  },
  viewSubscrive: {
    title: 'Détails de la souscription',
  },
  pays: 'Pays',
  permis: 'Type de permis',
  achievement: {
    label: 'Label',
    type: 'Type',
    path: 'URL',
  },
  addAchievement: 'Ajouter un lien ou une réalisation',
  updateCoordonnes: 'Modifiez vos informations',
  firstname: 'Prénom',
  lastname: 'Nom',
  email: 'Adresse mail',
  birthDate: 'Date de naissance',
  gender: 'Genre',
  code: 'Code',
  verfifBtn: 'Vérifier',
  sendCode: 'Envoyer le code',
  phone: 'Numéro de téléphone',
  codeTitle: 'Saisir le code',
  btnAnnuler: 'Annuler',
  cniNumber: 'Numéro CNI',
  cniRecto: ' CNI Recto',
  cniVerso: ' CNI Verso',
  photo: 'Photo',
  category: 'Catégorie',
  partner: {
    title: 'Partenaires',
    subTitle: 'Ma gestion partenaires',
    ourPartner: 'Nos partenaires3',
    receivedPartner: 'Demandes reçues',
    prospectsTab: 'Prospects',
    requestPartner: 'Demandes envoyées',
    name: 'Nom',
    address: 'Adresse postale',
    searchLabelBusiness: "Nom de l'entreprise",
    searchLabelSchool: "Nom de l'école",
    addPartner:
      'Établissez un partenariat avec une école pour être référencé dans leur vitrine et accéder facilement à leurs apprenants depuis la CVthèque.',
    addPartnerSchool:
      'Établissez un partenariat avec une entreprise pour être référencé dans leur vitrine et rendez visibles vos apprenants depuis leur CVthèque.',
  },
  candidature: {
    school: 'Formations',
    business: 'Emplois',
    favoris: 'Favoris',
    postuler: 'Postulés',
  },
  fraisInscription: "Frais d'inscription",
  faq: {
    title: "Besoin d'aide",
    subTitle: 'Utilisation de Linkpick',
  },
  fraisScolarite: 'Frais de scolarité',
  dureeFormation: 'Durée de la formation',
  conditionAdmission: "Condition d'admission",
  reconaissanceDiplome: 'Reconnaissance du diplôme',
  affiliationTitle: 'Affiliations',
  affiliationSubTitle: 'Mes candidats sélectionnés',
  fermer: 'Fermer',
  docProfilVerif: 'Type de document',
  btnSend: 'Envoyer',
  btnConfirm: 'Confirmer',
  newEmail: 'Nouvelle adresse mail',
  AddToFavorite: 'Ajouter aux favoris',
  AddedToFavorite: 'Ajoutée aux favoris',
  messagerie: {
    title: 'Messagerie',
    subTitle: 'Avec les organismes',
    subTitle2: 'En ligne',
  },
  notification: {
    title: 'Notifications',
    subTitle: 'Centre de notifications',
  },
  CVTheque: {
    title: 'CVThèque',
    subTitle: 'Candidats visibles et disponibles',
  },
});

export default frLang;
